<template>
  <div :class="sidebar ? 'nav-opened' : 'relative'">
    <header id="navbar" class="bb bt pb-5">
      <nav class="primary-row">
        <section class="logo-cell">
          <img
            class="logo show-md pointer"
            src="../../assets/img/img-logo.svg"
            data-test-id="header_logo_link"
            data-cy="bulletin-logo"
            @click="handleLogoClick"
          />
        </section>
        <section class="search-cell">
          <the-search-field />
        </section>
        <section class="controls-cell">
          <UserControls />
        </section>
      </nav>
      <the-navigation-bar-links />
      <sidebar :is-visible="sidebar" :categories="categories" :should-display-feed-link="true" />
    </header>
    <dropdown :categories="categories" />
  </div>
</template>

<script>
import TheSearchField from "@/components/navigation/TheSearchField";
import UserControls from "@/components/navigation/UserControls";
import Sidebar from "@/components/navigation/sidebar.vue";

import Dropdown from "@/components/navigation/Dropdown";

import NavigationApi from "@/services/api/NavigationApi";
import TheNavigationBarLinks from "@/components/navigation/TheNavigationBarLinks";
import { mapGetters } from "vuex";

const NavigationApiService = new NavigationApi();
export default {
  name: "TheNavigationBar",
  components: {
    TheNavigationBarLinks,
    Dropdown,
    UserControls,
    TheSearchField,
    Sidebar,
  },
  data() {
    return {
      categories: [],
    };
  },
  computed: {
    ...mapGetters({
      sidebar: "navigation/sidebar",
    }),
  },
  beforeMount() {
    this.loadCategories();
  },
  mounted() {
    window.addEventListener("resize", () => {
      if (window.innerWidth > this.$utils.constants.BREAKPOINT_MEDIUM) {
        if (this.sidebar === true) {
          this.$store.dispatch("navigation/hideSideBar");
        }
      }
    });
  },
  methods: {
    async loadCategories() {
      this.categories = (await NavigationApiService.getNavigation()).data[0];
    },
    handleLogoClick() {
      this.$ma.trackEvent({
        action: "Navigation Click",
        properties: {
          "Page Title": "Logo",
          "Page Type": "Logo",
        },
      });
      this.$router.push("/");
      this.$store.dispatch("navigation/setDropdownType", "closed");
      this.$store.dispatch("navigation/hideSideBar");
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-opened {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: 999;
  bottom: 0;
}
</style>
